export default {
  candidate: {
    name: '',
    phone: '',
    email: '',
    agreeTOS: false,
    link: '',
    city: '',
    attachments: [],
    additionalFieldResponses: [],
    atsCandidateId: '',
  },
  messages: {
    questions: [],
    videoResponses: [],
  },
}
